import { Checkbox } from "./Checkbox";
import "./Checkbox.scss";

export default Checkbox;
